import {TourStep} from "@app-types/tour.types.ts";


export const initCatalogueTourSteps: TourStep[] = [
    {
        title: 'Bienvenido',
        description: 'Te mostramos las novedades del catálogo. Podés cerrar el tour cuando quieras y volver a abrirlo desde el botón de ayuda.',
        target: {
            modal: true,
        },
        executeBefore: 'closeCatalogueFilters',
    },
    {
        title: 'Resumen del catálogo',
        description: 'En el encabezado vas a encontrar la información clave: categoría activa, filtros aplicados, resultados y accesos rápidos.',
        target: {
            class: '.catalogue-hero__content',
        },
        optional: true,
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Filtros rápidos',
        description: 'Desde este botón abrís el panel lateral para ajustar filtros, ordenar resultados y limpiar tu búsqueda en segundos.',
        target: {
            class: '.catalogue-toolbar__toggle',
        },
        optional: true,
        onlyVisible: true,
        executeBefore: 'closeCatalogueFilters',
    },
    {
        title: 'Buscador inteligente',
        description: 'Podés buscar por nombre, código o descripción. El panel se adapta a mobile y guarda tu último criterio.',
        target: {
            class: '.catalogue-menu__search input',
        },
        optional: true,
        onlyVisible: true,
        fullyInView: true,
        executeBefore: 'openCatalogueFilters',
    },
    {
        title: 'Orden y limpieza',
        description: 'Elegí cómo ordenar los resultados y, si aplicaste filtros, limpiarlos desde este mismo panel.',
        target: {
            class: '.catalogue-menu__select',
        },
        optional: true,
        onlyVisible: true,
        fullyInView: true,
        executeBefore: 'openCatalogueFilters',
    },
    {
        title: 'Explorá por categorías',
        description: 'Usá el árbol de categorías para profundizar en subcategorías y ver destacados con un solo toque.',
        target: {
            class: '.catalogue-menu__tree-view',
        },
        optional: true,
        onlyVisible: true,
        fullyInView: true,
        executeBefore: 'openCatalogueFilters',
    },
    {
        title: 'Filtros activos',
        description: 'Los filtros aplicados aparecen arriba como chips. Podés quitarlos uno a uno o limpiar todo.',
        target: {
            class: '.catalogue-toolbar__filters',
        },
        optional: true,
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Tarjeta de producto',
        description: 'Cada tarjeta resume precios, badges de stock y accesos directos. Desde el botón del carrito sumás la unidad al instante.',
        target: {
            class: '.catalogue-card',
        },
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Ver carrito',
        description: 'Accedé al resumen de tu compra y al checkout desde el ícono del carrito. Siempre muestra la cantidad actualizada.',
        target: {
            class: '.cartButtonClass',
        },
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Centro de ayuda',
        description: '¿Necesitás repetir el tour o escribirnos por WhatsApp? Abrí el botón flotante para acceder a ayuda y canales directos.',
        target: {
            class: '.float-button',
        },
        optional: true,
        onlyVisible: true,
        fullyInView: true,
    },
];



export const CartTourSteps: TourStep[] = [
    {
        title: 'Abrí tu carrito',
        description: 'Desde el ícono vas a ver los productos agregados, aplicar cupones y saltar directo al checkout.',
        target: {
            class: '.cartButtonClass',
        },
        onlyVisible: true,
        fullyInView: true,
        executeBefore: 'closeCart',
    },
    {
        title: 'Aplicá cupones',
        description: 'Ingresá códigos promocionales y revisá las bonificaciones disponibles sin salir del panel.',
        target: {
            class: '.voucherClass',
            allowHidden: true,
        },
        onlyVisible: true,
        fullyInView: true,
        executeBefore: 'openCart',
    },
    {
        title: 'Ajustá cantidades',
        description: 'Sumá o restá unidades desde acá. Si un producto requiere variantes, te vamos a guiar antes de confirmarlo.',
        target: {
            class: '.cartItemListClass .editQtyBtnsClass',
            allowHidden: true,
        },
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Quitar un producto',
        description: 'Podés eliminar un ítem específico con este botón. Te pediremos confirmación para evitar errores.',
        target: {
            class: '.cartItemListClass .removeFromCartClass',
            allowHidden: true,
        },
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Vaciar carrito',
        description: 'Si necesitás empezar de cero, acá eliminás todos los productos. Recordá que la acción no se puede deshacer.',
        target: {
            class: '.removeAllFromCartClass',
            allowHidden: true,
        },
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Totales claros',
        description: 'Revisá el subtotal, descuentos y el estimado a pagar antes de continuar. Se actualiza automáticamente.',
        target: {
            class: '.totalsCartSectionClass',
            allowHidden: true,
        },
        optional: true,
        onlyVisible: true,
        fullyInView: true,
    },
    {
        title: 'Ir al checkout',
        description: 'Cuando estés listo, continuá al checkout para elegir envío y medio de pago.',
        target: {
            class: '.checkoutBtnClass',
            allowHidden: true,
        },
        onlyVisible: true,
        fullyInView: true,
    },
];

